import React from 'react';
import { useDropzone } from 'react-dropzone';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function DragAndDropUpload({ onFilesAccepted }) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: { 'image/*': [] },
    onDrop: acceptedFiles => onFilesAccepted(acceptedFiles),
  });

  return (
    <Box
      {...getRootProps()}
      sx={{
        border: '0.4vw dashed #93AC5B',
        p: 4,
        textAlign: 'center',
        bgcolor: isDragActive ? 'eab2a4' : '#EFEEEA',
        cursor: 'pointer',
        borderRadius: "2vw",
        margin: '2rem auto',
        maxWidth: 400,
      }}
    >
      <input {...getInputProps()} />
      <Typography variant="h6">
        {isDragActive
          ? '+ '
          : 'Drag & drop an image here, or click to select'}
      </Typography>
    </Box>
    
  );
}
